import {Anchor} from '@mantine/core';
import React from 'react';

export default function MoleculeVersionBanner({
  onSeeAllVersions,
}: {
  onSeeAllVersions: () => void;
}): JSX.Element {
  return (
    <span>
      You&apos;re viewing an older version of this chemical structure. See all versions{' '}
      <Anchor component="button" type="button" onClick={onSeeAllVersions}>
        here
      </Anchor>
      .
    </span>
  );
}
